import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-trending-news',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-trending-news.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonTrendingNewsComponent {
  itemsSkel = Array.from({ length: 3 });
}
